import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-13e4444b"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "add-sub"
};
const _hoisted_2 = {
  class: "myform"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("账号");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("名称");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("密码");

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  登录密码必需包含大小写字母和数字，最少8位", -1));

const _hoisted_7 = /*#__PURE__*/_createTextVNode("功能权限");

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他通用", -1));

const _hoisted_9 = {
  style: {
    "margin-top": "10px"
  }
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定添加");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");

  const _component_el_input = _resolveComponent("el-input");

  const _component_warning_filled = _resolveComponent("warning-filled");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_popover = _resolveComponent("el-popover");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_checkbox = _resolveComponent("el-checkbox");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 2
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 22
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.name.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.name = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          placeholder: "请输入登录账号",
          clearable: "",
          onFocus: _cache[1] || (_cache[1] = $event => $data.err.name.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.name.content), 1)])]),
        _: 1
      }, 8, ["visible"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 2
    }, {
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 22
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.uname.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.uname,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.uname = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          placeholder: "请输入名称",
          clearable: "",
          onFocus: _cache[3] || (_cache[3] = $event => $data.err.uname.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.uname.content), 1)])]),
        _: 1
      }, 8, ["visible"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 2
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 22
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.pwd.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.pwd,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.pwd = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          placeholder: "请输入登录密码",
          clearable: "",
          "show-password": "",
          type: "password",
          onFocus: _cache[5] || (_cache[5] = $event => $data.err.pwd.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.pwd.content), 1)])]),
        _: 1
      }, 8, ["visible"]), _hoisted_6]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 2
    }, {
      default: _withCtx(() => [_hoisted_7]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 22,
      style: {
        "padding": "10px",
        "text-align": "center"
      }
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menu, fz => {
        return _openBlock(), _createBlock(_component_el_row, {
          class: "theme-border-half fz",
          key: fz.name
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 3,
            style: _normalizeStyle({
              'line-height': fz.mk.length * 30 - 6 + 'px'
            })
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox, {
              modelValue: fz.info.is_select,
              "onUpdate:modelValue": $event => fz.info.is_select = $event,
              label: fz.name,
              size: "small",
              onChange: $event => $options.change_item_fz(fz, $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onChange"])]),
            _: 2
          }, 1032, ["style"]), _createVNode(_component_el_col, {
            span: 21
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fz.mk, mk => {
              return _openBlock(), _createBlock(_component_el_row, {
                class: "theme-border-half mk",
                key: mk.name
              }, {
                default: _withCtx(() => [mk.name == '其他通用' ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 4,
                  class: "qtty"
                }, {
                  default: _withCtx(() => [_hoisted_8]),
                  _: 1
                })) : (_openBlock(), _createBlock(_component_el_col, {
                  key: 1,
                  span: 4
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                    modelValue: mk.info.is_select,
                    "onUpdate:modelValue": $event => mk.info.is_select = $event,
                    label: mk.name,
                    size: "small"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])]),
                  _: 2
                }, 1024)), _createVNode(_component_el_col, {
                  class: "theme-border-half ff",
                  span: 20
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mk.ff, ff => {
                    return _openBlock(), _createBlock(_component_el_col, {
                      key: ff.name,
                      span: 4,
                      style: {
                        "margin-left": "10px"
                      }
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                        modelValue: ff.info.is_select,
                        "onUpdate:modelValue": $event => ff.info.is_select = $event,
                        label: ff.name,
                        size: "small"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])]),
                      _: 2
                    }, 1024);
                  }), 128))]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.post_change
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  }, 8, ["onClick"])])]);
}